import fetch from 'cross-fetch';
import { actLoginTimedOut } from 'actions/loginStateActions';
import { actUploadFilesRecord } from 'actions/fileAction';
import { ApiPrefix, json, statusCheck, getCookie } from '../util/icwUtility';

// INIT Functions

export const PRODUCT_MANAGER_LIST_INIT = 'PRODUCT_MANAGER_LIST_INIT';
export function actProductManagerListInit() {
  return { type: PRODUCT_MANAGER_LIST_INIT };
}

// Get Product List

export const PRODUCT_MANAGER_GET_PRODUCT_LIST_BEGIN = 'PRODUCT_MANAGER_GET_PRODUCT_LIST_BEGIN';
function actProductManagerGetProductListBegin() {
  return { type: PRODUCT_MANAGER_GET_PRODUCT_LIST_BEGIN };
}

export const PRODUCT_MANAGER_GET_PRODUCT_LIST_SUCCESS = 'PRODUCT_MANAGER_GET_PRODUCT_LIST_SUCCESS';
export function actProductManagerGetProductListSuccess(data, total) {
  return { type: PRODUCT_MANAGER_GET_PRODUCT_LIST_SUCCESS, data, total };
}

export const PRODUCT_MANAGER_GET_PRODUCT_LIST_FAIL = 'PRODUCT_MANAGER_GET_PRODUCT_LIST_FAIL';
function actProductManagerGetProductListFail(reason) {
  return { type: PRODUCT_MANAGER_GET_PRODUCT_LIST_FAIL, reason };
}

export function actProductManagerGetProductList() {
  return (dispatch) => {
    dispatch(actProductManagerGetProductListBegin());
    return fetch(`${ApiPrefix}/product/list`, {
      headers: { Authorization: getCookie('token') },
    })
      .then(statusCheck)
      .then(json)
      .then((data) => dispatch(actProductManagerGetProductListSuccess(data.list, data.total)))
      .catch((err) => {
        if (err.status === 401) {
          dispatch(actLoginTimedOut());
        }

        dispatch(actProductManagerGetProductListFail(typeof err === 'object' ? err.message : err));
      });
  };
}

// POST PRODUCT PROFILE

export const PRODUCT_MANAGER_POST_PRODUCT_BEGIN = 'PRODUCT_MANAGER_POST_PRODUCT_BEGIN';
function actProductManagerPostProductBegin() {
  return { type: PRODUCT_MANAGER_POST_PRODUCT_BEGIN };
}

export const PRODUCT_MANAGER_POST_PRODUCT_SUCCESS = 'PRODUCT_MANAGER_POST_PRODUCT_SUCCESS';
export function actProductManagerPostProductSuccess(data) {
  return { type: PRODUCT_MANAGER_POST_PRODUCT_SUCCESS, data };
}

export const PRODUCT_MANAGER_POST_PRODUCT_FAIL = 'PRODUCT_MANAGER_POST_PRODUCT_FAIL';
function actProductManagerPostProductFail(reason) {
  return { type: PRODUCT_MANAGER_POST_PRODUCT_FAIL, reason };
}

export const actProductManagerPostProduct = (filesDz, formData, companyId, deleteData) => (
  dispatch
) => {
  dispatch(actProductManagerPostProductBegin());

  const { files, path } = filesDz;

  actUploadFilesRecord(files, path).then(async (productThumbnail) => {
    const response = await fetch(`${ApiPrefix}/product`, {
      method: 'POST',
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        formData,
        productThumbnail,
        companyId,
        deleteData,
      }),
    })
      .then(statusCheck)
      .then(json)
      .then((data) => data)
      .catch((err) => {
        if (err.status === 401) {
          dispatch(actLoginTimedOut());
        }
        dispatch(actProductManagerPostProductFail(typeof err === 'object' ? err.message : err));
      });

    const product = await fetch(`${ApiPrefix}/product/${response.id}`, {
      headers: { Authorization: getCookie('token') },
    })
      .then(statusCheck)
      .then(json)
      .then((data) => data)
      .catch((err) => {
        if (err.status === 401) {
          dispatch(actLoginTimedOut());
        }
      });

    if (product) {
      dispatch(
        actProductManagerPostProductSuccess({
          id: product.id,
          name: product.name,
          itemNo: product.itemNo,
          updatedAt: product.updatedAt,
          productSupplierMaps: product.suppliers.data,
          productProductCategoryMaps: product.productCategories.data,
          productBuyerMaps: product.buyers.data,
          productFactoryMaps: product.factories.data,
          productFiles: product.files.default.fileArr,
        })
      );
    }
  });
};

// SEARCH AND FILTER PRODUCT LIST

export const PRODUCT_MANAGER_POST_PRODUCT_LIST_BEGIN = 'PRODUCT_MANAGER_POST_PRODUCT_LIST_BEGIN';
function actProductManagerPostProductListBegin() {
  return { type: PRODUCT_MANAGER_POST_PRODUCT_LIST_BEGIN };
}

export const PRODUCT_MANAGER_POST_PRODUCT_LIST_SUCCESS =
  'PRODUCT_MANAGER_POST_PRODUCT_LIST_SUCCESS';
export function actProductManagerPostProductListSuccess(data, total) {
  return { type: PRODUCT_MANAGER_POST_PRODUCT_LIST_SUCCESS, data, total };
}

export const PRODUCT_MANAGER_POST_PRODUCT_LIST_FAIL = 'PRODUCT_MANAGER_POST_PRODUCT_LIST_FAIL';
function actProductManagerPostProductListFail(reason) {
  return { type: PRODUCT_MANAGER_POST_PRODUCT_LIST_FAIL, reason };
}

export function actProductManagerPostProductList({
  keyword,
  searchBy,
  criterions,
  isActive,
  pageNo,
  pageSize,
  companyId,
  orderBy,
}) {
  return (dispatch) => {
    dispatch(actProductManagerPostProductListBegin());
    return fetch(`${ApiPrefix}/product/list`, {
      method: 'POST',
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        keyword,
        searchBy,
        criterions,
        isActive,
        pageNo,
        pageSize,
        companyId,
        orderBy,
      }),
    })
      .then(statusCheck)
      .then(json)
      .then((data) => dispatch(actProductManagerPostProductListSuccess(data.list, data.total)))
      .catch((err) => {
        if (err.status === 401) {
          dispatch(actLoginTimedOut());
        }

        dispatch(actProductManagerPostProductListFail(typeof err === 'object' ? err.message : err));
      });
  };
}
